import React, { useState, MouseEvent, ChangeEvent } from 'react'
import parse from 'html-react-parser'
import Page from '../types/Page'
import Item, { ItemLevel1, ItemLevel2 } from '../types/Item'
import Level2LayoutProps from '../types/Level2LayoutProps'

export default ({ level1active, level2, handleClose }: Level2LayoutProps) => {
  return (
    <div className={'level-2'} id={level1active.slug}>
      {/*<div className="close-button" onClick={handleClose}>Close</div>*/}
      <div className={'switchboard' + (level1active.menusRightText ? ' has-right' : '')}>
        <div className="main-column">
          <ul>
            {level2}
          </ul>
        </div>
        {level1active.menusRightText &&
          <div className="right-column">{parse(level1active.menusRightText)}</div>
        }
      </div>
    </div>
  )
}
